<script lang="ts" setup>
  import { useRouter } from 'vue-router'
  import Contact from '@/components/Molecules/Contact.vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import { onBeforeMount, ref } from 'vue'
  import { usePlugin } from '@/store/Pinia/usePlugin.store'
  import { getOs, UserOperateSystem } from '@/utils/getOs'
  import sendClarityEvent from '@/utils/sendClarityEvent'
  import { useEmbedConfig } from '@/composables'

  const router = useRouter()
  const { isEmbedMode } = useEmbedConfig()
  const pluginStore = usePlugin()
  const csrDownloadLink = ref('')
  const os = getOs()

  function goToInstallInstructions() {
    sendClarityEvent('installInstructionsAccess')

    if (os.os === UserOperateSystem.LINUX) {
      window.open(
        'https://solutimanuais.gitbook.io/manual-de-emissao-e-instalacao-de-certificados-a1/instalacao-do-certificado-digital-a1/04-instalando-o-certificado-digital/instalacao-linux',
      )
      return
    }

    if (os.os === UserOperateSystem.WINDOWS) {
      window.open(
        'https://solutimanuais.gitbook.io/manual-de-emissao-e-instalacao-de-certificados-a1/instalacao-do-certificado-digital-a1/04-instalando-o-certificado-digital/instalacao-windows',
      )
      return
    }

    if (os.os === UserOperateSystem.MACOS) {
      window.open(
        'https://solutimanuais.gitbook.io/manual-de-emissao-e-instalacao-de-certificados-a1/instalacao-do-certificado-digital-a1/04-instalando-o-certificado-digital/instalacao-macos',
      )
      return
    }

    window.open(
      'https://solutimanuais.gitbook.io/manual-de-emissao-e-instalacao-de-certificados-a1/instalacao-do-certificado-digital-a1/04-instalando-o-certificado-digital',
    )
  }

  onBeforeMount(async () => {
    if (!pluginStore.csrDownloadLink.trim()) {
      router.replace({
        path: '/issue/plugin',
      })

      return
    }

    csrDownloadLink.value = pluginStore.csrDownloadLink
    pluginStore.clear()
  })
</script>

<template>
  <div class="container">
    <section class="page-title-wrapper text-center pt-5">
      <h2 class="fw-600 pt-2">
        Parabéns! Seu Certificado está pronto para instalação!
      </h2>
    </section>

    <section v-if="isEmbedMode" class="d-flex justify-content-center pt-5">
      <img
        class="img-style d-block mx-auto"
        src="@/SignaturePlugin/A1/assets/download-csr-view.svg"
        alt="Imagem pessoa feliz"
      />
    </section>

    <template v-else>
      <section class="row pt-5">
        <div class="col-md-6 d-none d-lg-block">
          <div class="d-flex justify-content-end">
            <img
              class="img-style mx-5"
              src="@/SignaturePlugin/A1/assets/download-csr-view.svg"
              alt="Imagem pessoa feliz"
            />
          </div>
        </div>

        <div class="col-12 col-lg-6">
          <div class="install-instructions-card px-4 py-4">
            <h3 class="install-instructions-card-title mb-4">
              Como instalar seu Certificado?
            </h3>

            <div class="d-flex align-items-start mb-3">
              <div class="purple-circle me-2">
                <span>1</span>
              </div>
              <p class="text-start fs-6">
                <strong>Encontre a pasta do Certificado</strong> no seu
                computador.
              </p>
            </div>

            <div class="d-flex align-items-start">
              <div class="purple-circle me-2">
                <span>2</span>
              </div>
              <p class="text-start fs-6">
                <strong>Clique no botão abaixo</strong> e siga o passo a passo
                para instalação.
              </p>
            </div>

            <div>
              <button class="btn btn-primary" @click="goToInstallInstructions">
                <icon name="arrow-up-right-from-square" class="me-2" />
                Veja como instalar
              </button>
            </div>
          </div>

          <div
            class="info-footer d-flex align-items-center justify-content-center py-3 my-4"
          >
            <span class="fs-6">
              Não conseguiu baixar o Certificado?
              <a class="link" :href="csrDownloadLink" target="_blank">
                Clique aqui
              </a>
            </span>
          </div>
        </div>
      </section>

      <section class="py-3">
        <contact />
      </section>
    </template>
  </div>
</template>

<style scoped>
  .btn-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: center;
    flex-direction: row;
  }

  @media screen and (max-width: 768px) {
    .btn-wrap {
      flex-direction: column;
    }
  }

  .img-style {
    width: 100%;
    max-width: 368px;
  }

  .install-instructions-card {
    background-color: #f0f0f3;
    border-radius: 1rem;
    max-width: 32rem;
  }

  .install-instructions-card-title {
    color: #5500af;
    font-size: 1.6rem;
    font-weight: 600;
    text-align: start;
  }

  .purple-circle {
    width: 1.5rem;
    height: 1.5rem;
    padding: 0.75rem;
    border-radius: 50%;
    background-color: #5500af;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 1rem;
  }

  .link {
    font-size: 1rem;
    font-weight: 400;
    color: #0080a3;
    cursor: pointer;
  }

  .download-csr-btn {
    color: var(--color-primary);
    text-decoration: none;
    text-decoration-color: var(--color-primary);
  }

  .info-footer {
    border: 1px solid #83848f;
    border-radius: 15px;
    max-width: 32rem;
  }
</style>
